import { IconTrash } from "@tabler/icons-react";
import { Badge, IconButton, Stack, Text } from "@/components/ui";
import type { EventoDelCatalogo, NodoEvento } from "../../../services/notificaciones-service";
import type { EstadoLienzo } from "../../../utils/lienzo";
import { EncabezadoPanel } from "./PanelPropiedades";

/** Evento seleccionado: qué es, a qué notificaciones dispara y qué variables ofrece. */
export function PanelEvento({
  nodo, estado, catalogo, onQuitar,
}: { nodo: NodoEvento; estado: EstadoLienzo; catalogo: EventoDelCatalogo[]; onQuitar: () => void }) {
  const info = catalogo.find((e) => e.codigo === nodo.tipoEvento);
  const destinos = estado.conexiones
    .filter((c) => c.eventoClave === nodo.clave)
    .map((c) => estado.notificaciones.find((n) => n.clave === c.notificacionClave)?.nombre)
    .filter(Boolean);

  return (
    <div>
      <EncabezadoPanel
        titulo={info?.nombre ?? nodo.tipoEvento}
        subtitulo={info ? `Evento · ${info.categoria}` : "No existe en el catálogo"}
        acciones={
          <IconButton size="sm" aria-label="Quitar del lienzo" title="Quitar del lienzo" onClick={onQuitar}>
            <IconTrash />
          </IconButton>
        }
      />
      <Stack gap="md" className="p-4">
        {info?.descripcion ? <Text size="sm">{info.descripcion}</Text> : null}
        <div>
          <Text size="xs" fw={600} c="dimmed" tt="uppercase">Dispara</Text>
          <Text size="sm">{destinos.length > 0 ? destinos.join(", ") : "Aún nada · une este evento con una notificación."}</Text>
        </div>
        {info ? (
          <div>
            <Text size="xs" fw={600} c="dimmed" tt="uppercase">Variables disponibles · {info.variables.length}</Text>
            <ul className="mt-1 space-y-0.5">
              {info.variables.map((v) => (
                <li key={v.nombre} className="flex items-center justify-between gap-2 text-xs" title={v.descripcion ?? undefined}>
                  <span className="font-mono">{v.nombre}</span>
                  <Badge size="xs" color={v.origen === "enriquecida" ? "info" : "slate"} uppercase={false}>{v.tipo}</Badge>
                </li>
              ))}
            </ul>
          </div>
        ) : null}
        <Text size="xs" c="dimmed" ff="mono">{nodo.tipoEvento}</Text>
      </Stack>
    </div>
  );
}
